export default {"src":"/_next/static/media/instagram.00e6883d.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};